import GlobalFooter from 'components/global-footer/GlobalFooter';
import GlobalNavbar from 'components/global-navbar/GlobalNavbar';
import { Outlet } from 'react-router-dom';

const BaseLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-brand-cream">
      <GlobalNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <GlobalFooter />
    </div>
  );
};

export default BaseLayout;
